import React, {useEffect, useState} from 'react';
import {getToken} from '@/helpers/local-storage';
import {goURL} from '@/helpers/router';
import {checkScopes, searchRoleRedirect} from "@/utils/router";

interface IProps {
    children: React.ReactElement;
    isPublic: boolean;
    userScopes?: Array<string>;
    userRoles?:  Array<string>;
    routeScopes: Array<string>;
}

const Auth: React.FC<IProps> = (
    {
        children,
        isPublic,
        userScopes,
        userRoles,
        routeScopes
    }
) => {
    const [renderRoute, setRenderRoute] = useState(false);
    
    useEffect(() => {
        if (!getToken()) {
            // not logged
            if (!isPublic) {
                // no public path. go to login
                goURL('/auth/login');
            }
            
            setRenderRoute(true);
        } else {          
            // logged and check scopes
            
            // get redirect
            if (userRoles && userRoles.length > 0) {
                const redirect = searchRoleRedirect(userRoles[0]);
                //console.log('redirect', redirect);

                // check if can render route
                const canRender = checkScopes(routeScopes, userScopes);
                //console.log('canRender', canRender);

                // no permissions allowed
                if (!canRender) {
                    // redirect to main url when login
                    goURL(redirect);
                }
            }

            setRenderRoute(true);
        }
    }, [isPublic, routeScopes, userRoles, userScopes]);

    return renderRoute ? children : null;
};

export default Auth;
